import React from 'react'
import SecurityHero from './securityHero/SecurityHero'
import SecurityWhat from './securityWhat/SecurityWhat'
import SecurityCapability from './securityCapability/SecurityCapability'
import SecurityService from './securityService/SecurityService'
import SecurityTestimonial from './securityTestimonial/SecurityTestimonial'
import SecurityChoose from './securityChoose/SecurityChoose'
import SecurityBenefit from './securityBenefit/SecurityBenefit'
import SecurityPipeline from './securityPipeline/SecurityPipeline'
import SecurityApproach from './securityApproach/SecurityApproach'

export default function Security() {
  return (
    <div>
        <SecurityHero/>
        <SecurityWhat/>
        <SecurityCapability/>
        <SecurityBenefit/>
        <SecurityChoose/>
        <SecurityApproach/>
        <SecurityPipeline/>
        <SecurityTestimonial/>
        <SecurityService/>
    </div>
  )
}
